import type { TesteCatalogoItem } from "@/types/teste-modulo";

// Catálogo das funções do módulo de impressão que devem ser testadas.
// Ordem = ordem em que aparecem na tela e são executadas em "Rodar automáticos".
//
// tipo:
//  - "auto"    → o sistema envia o comando pelo socket e decide PASS/FAIL sozinho.
//  - "hibrido" → o sistema aciona a função, mas o técnico confirma o resultado físico.
//  - "manual"  → só o técnico observa e marca (sem integração com o socket).
export const TESTES_CATALOGO: TesteCatalogoItem[] = [
  {
    chave: "conexao_ws",
    nome: "Conexão com o módulo",
    categoria: "Conexão",
    tipo: "auto",
    descricao:
      "Verifica se o módulo está conectado ao servidor via WebSocket usando o serial (hardware_id) configurado.",
    sugestao:
      "Confirme se o módulo está ligado e conectado à rede Wi-Fi. Verifique se o serial/hardware_id do perfil de impressão corresponde ao do equipamento. Reinicie o módulo e aguarde reconectar.",
  },
  {
    chave: "status_firmware",
    nome: "Status e firmware",
    categoria: "Diagnóstico",
    tipo: "auto",
    descricao:
      "Envia o comando ST e lê a resposta INFO do módulo, capturando a versão de firmware, MAC, rede e disponibilidade.",
    sugestao:
      "O módulo não respondeu ao status. Verifique alimentação e conexão Wi-Fi. Se persistir, o firmware pode estar travado — regrave o firmware na versão homologada.",
  },
  {
    chave: "sinal_wifi",
    nome: "Sinal Wi-Fi (RSSI)",
    categoria: "Conexão",
    tipo: "auto",
    descricao:
      "Avalia a intensidade do sinal Wi-Fi reportado pelo módulo. Reprova quando o sinal está fraco demais para operação estável.",
    sugestao:
      "Sinal Wi-Fi fraco. Aproxime o módulo do roteador, reposicione a antena ou use um repetidor. Sinal fraco causa quedas de conexão durante a impressão.",
  },
  {
    chave: "impressao_teste",
    nome: "Impressão de etiqueta de teste",
    categoria: "Impressão",
    tipo: "hibrido",
    descricao:
      "Envia uma etiqueta de teste para o módulo imprimir.",
    instrucao:
      "Confirme se a etiqueta saiu e se está legível (texto nítido, sem falhas, alinhada).",
    sugestao:
      "Verifique o rolo de etiquetas e o ribbon, a cabeça de impressão (limpeza/desgaste), a tensão/velocidade e o alinhamento do sensor. Confira também se o ZPL padrão está correto.",
  },
  {
    chave: "leitura_tag",
    nome: "Leitura de tag RFID",
    categoria: "RFID",
    tipo: "hibrido",
    descricao:
      "Envia o comando LEPR e aguarda o módulo devolver o EPC de uma tag aproximada da antena.",
    instrucao:
      "Aproxime uma tag da antena antes/durante o teste e confirme se o EPC lido corresponde à tag.",
    sugestao:
      "Nenhuma tag foi lida. Verifique a antena e o cabo coaxial, aumente a potência RF, aproxime a tag e teste com uma tag sabidamente boa. Confirme se a antena correta está conectada.",
  },
  {
    chave: "gravacao_tag",
    nome: "Gravação de tag RFID",
    categoria: "RFID",
    tipo: "hibrido",
    descricao:
      "Grava um EPC em uma tag virgem durante a impressão e confere a gravação.",
    instrucao:
      "Grave uma etiqueta e confirme se o EPC foi gravado e conferido com sucesso (sem erro de gravação).",
    sugestao:
      "Falha na gravação. Verifique o delay e as tentativas de gravação no perfil, a potência RF, a posição da tag na etiqueta e a compatibilidade da tag virgem (chip/inlay).",
  },
  {
    chave: "calibracao_rf",
    nome: "Calibração / leitura contínua",
    categoria: "RFID",
    tipo: "hibrido",
    descricao:
      "Inicia a leitura contínua (IL) na potência configurada e coleta as tags detectadas com seus níveis de sinal (RSSI).",
    instrucao:
      "Aproxime uma ou mais tags e confirme se aparecem na leitura com RSSI coerente. Depois pare a leitura.",
    sugestao:
      "Leitura contínua instável ou sem detecção. Verifique antena, cabo e potência RF. RSSI muito baixo indica antena mal conectada ou tag distante/blindada.",
  },
  {
    chave: "bloqueador",
    nome: "Bloqueador RF instalado",
    categoria: "Montagem",
    tipo: "manual",
    descricao:
      "Confirma se o bloqueador (isolamento de RF) foi instalado quando o equipamento exige.",
    instrucao:
      "Marque PASS se o bloqueador foi instalado corretamente (ou não se aplica a este equipamento). Marque FAIL se deveria ter e não tem.",
    sugestao:
      "Instale o bloqueador RF. Sem ele, o leitor pode capturar tags fora da área desejada, gerando leituras/gravações indevidas.",
  },
  {
    chave: "montagem_fisica",
    nome: "Montagem física",
    categoria: "Montagem",
    tipo: "manual",
    descricao:
      "Verifica a montagem geral do equipamento: gabinete, parafusos, conexões, cabos e acabamento.",
    instrucao:
      "Confira se está tudo firme e bem conectado, sem cabos soltos ou peças frouxas.",
    sugestao:
      "Revise a montagem: reaperte parafusos, prenda cabos soltos e confirme conectores encaixados. Registre com foto qualquer ponto de atenção.",
  },
  {
    chave: "alimentacao",
    nome: "Alimentação / energia",
    categoria: "Energia",
    tipo: "manual",
    descricao:
      "Confirma que a fonte e a alimentação estão estáveis e dentro do especificado.",
    instrucao:
      "Verifique se a fonte é a correta e se o equipamento liga e opera sem reiniciar sozinho.",
    sugestao:
      "Troque/valide a fonte de alimentação. Reinícios espontâneos indicam fonte subdimensionada, mau contato no conector ou cabo danificado.",
  },
];
